// VERSION 1.3
<template>
    <div class="ytplayer">
        
        <!-- <modal @before-close="removeOverFlow" :ref="'modal_'+videoData.id" @before-open="[nowPlaying = videoData.id, beforeModalOpen]" :width="modalWidth" :height="'90%'" :maxWidth="modalMaxWidth" :adaptive="true" :key="videoData.id" :name="videoData.id"> -->
        <modal @before-close="removeOverFlow" @opened="modalOpened" :ref="'modal_'+videoData.id" @before-open="beforeModalOpen" :width="modalWidth" :height="'90%'" :maxWidth="modalMaxWidth" :adaptive="true" :key="videoData.id" :name="videoData.id">
                <div class="header">
                    <i @click="$modal.hide(videoData.id)" class="fas fa-window-close"></i>
                </div>
                <div class="modalContentWrapper" :class="[showPlaylistColumn?'contentSidebarColumn':'noContentSidebarColumn']">
                <div :class="['contentContainer', ]">
                    
                    <div class="youtubeWrapper">
                        <div class="videoPlayerContainer" :ref="videoData.id+'Ref'" :class="[videoLoading?'hide':'']">
                        <!-- <youtube class="youtubeComponent" @ready="videoReady(videoData.id)" @playing="videoPlaying(videoData.id)" :player-vars="{rel: 0}" :ref="videoData.id+'search'" :video-id="videoData.snippet.resourceId.videoId" :fitParent="true"></youtube> -->
                        <youtube class="youtubeComponent" @error="errorYoutube" @ready="videoReady(videoData.id)" @playing="videoPlaying(videoData.id)" :player-vars="{rel: 0, origin: windowLocationOrigin}" :ref="videoData.id+'search'" :video-id="videoData.snippet.resourceId.videoId" :resize="false" :fitParent="true" :host="'https://www.youtube-nocookie.com'"></youtube>
                        </div>
                        <div class="videoPlayerContainer loadingIcon" v-if="videoLoading && !iframeError">
                            
                            <div class="pnLogoOuterWrapper" ref="pnLogoOuterWrapperRef">
                                
                                <div class="pnLogoOuterRing"></div>
                                <div class="pnLogoOuterRing2 animationScaleUp"></div>
                                <div class="pnLogoInnerWrapper">
                                
                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 141.7 141.7" style="enable-background:new 0 0 141.7 141.7;" xml:space="preserve">

                                        <path fill="#e8b761" d="M72.3,46.8H37.8l11.3,71.4H91l11.3-71.4H69.5l0.2-17.6h28.3l9.7-9.8c-0.8-1.6-1.3-3.5-1.3-5.4
                                            c0-6.8,5.5-12.4,12.4-12.4c6.8,0,12.4,5.5,12.4,12.4s-5.5,12.4-12.4,12.4c-1.1,0-2.1-0.1-3-0.4l-3.2,3.3h8.1c4.9,0,8.8,4,8.8,8.8
                                            s-4,8.8-8.8,8.8h-3.6l-3.7,23.4h3.2c1-4.8,3.4-8.1,6.3-8.1c3.7,0,6.8,5.9,6.8,13.2s-3,13.2-6.8,13.2c-2.8,0-5.3-3.3-6.3-8.1h-4.8
                                            l-6.1,38.2c3.7,1.1,6.3,4.4,6.3,8.5c0,4.9-4,8.8-8.8,8.8H36.6c-4.9,0-8.8-4-8.8-8.8c0-4.2,2.9-7.7,6.8-8.6l-6-38.1h-4.8
                                            c-1,4.8-3.4,8.1-6.3,8.1c-3.7,0-6.8-5.9-6.8-13.2s3-13.2,6.8-13.2c2.8,0,5.3,3.3,6.3,8.1h3.2l-3.7-23.4h-3.6c-4.9,0-8.8-4-8.8-8.8
                                            s4-8.8,8.8-8.8h51.9L72.3,46.8L72.3,46.8z"/>
                                    </svg>
        
                                </div>
                            </div>

                        </div>
                        <div class="videoPlayerContainer errorWrapper flex" v-if="iframeError">
                            <div class="errorContainer">
                                <div>
                                    <p class="errorTitle d-inline">{{webmessages.wsm_ccdisabledCookies}}</p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"><path d="M24.548 10.96a11.55 11.55 0 0 0-4.478-7.702c-.6-.133-.534.44-.386.553a10.87 10.87 0 0 1 4.282 8.334 1.78 1.78 0 0 0-1.173-.44 1.79 1.79 0 0 0-1.788 1.787 1.79 1.79 0 0 0 1.788 1.788 1.8 1.8 0 0 0 .842-.21c-.358 1.394-1 2.726-1.906 3.922-5.442 7.188-16.574 5.02-19.053-3.475-.07-.237.125-.465.377-.443a4.35 4.35 0 0 0 1.87-.239 4.4 4.4 0 0 0 .788-.372c.382-.23.037-.807-.346-.578a3.74 3.74 0 0 1-.668.315 3.7 3.7 0 0 1-1.583.203c-.723-.064-1.287.6-1.084 1.303C3.445 20.558 7.926 24 13.104 24c7 0 12.323-6.334 11.444-13.04zm-1.755 3.646c-.614 0-1.113-.5-1.113-1.114s.5-1.113 1.113-1.113 1.113.5 1.113 1.113-.5 1.114-1.113 1.114zM6.806 13.532a4.43 4.43 0 0 0 .945-1.925c.02-.096.096-.17.188-.184a5.23 5.23 0 0 0 .957-.245c2.544-.907 4-3.57 3.4-6.198-.062-.264-.005-.54.155-.758.418-.57.95-1.367 1.12-1.936.12-.406.515-.66.938-.606 1.262.162 2.476.543 3.6 1.132.396.205.707-.393.3-.598a11.49 11.49 0 0 0-3.834-1.203 1.53 1.53 0 0 0-1.67 1.084c-.1.37-.47.984-1.017 1.728a1.6 1.6 0 0 0-.268 1.31 4.61 4.61 0 0 1-2.958 5.4 4.6 4.6 0 0 1-.836.213c-.365.058-.663.343-.742.7-.128.6-.405 1.164-.8 1.632-.3.344.23.773.514.435z"></path><path d="M18.482 4.96c-1.06 0-1.923.862-1.923 1.923s.863 1.923 1.923 1.923 1.923-.863 1.923-1.923-.863-1.923-1.923-1.923zm0 3.172a1.25 1.25 0 0 1-1.249-1.249 1.25 1.25 0 0 1 1.249-1.249 1.25 1.25 0 0 1 1.249 1.249 1.25 1.25 0 0 1-1.249 1.249zm-4.2 4.368a1.35 1.35 0 0 0-1.349-1.349 1.35 1.35 0 0 0-1.35 1.349 1.35 1.35 0 0 0 1.35 1.349 1.35 1.35 0 0 0 1.349-1.349zm-2.024 0c0-.373.303-.675.675-.675s.675.303.675.675-.303.675-.675.675-.675-.302-.675-.675zm-7.54-4.833a1.35 1.35 0 0 0 1.349-1.349 1.35 1.35 0 0 0-1.349-1.349 1.35 1.35 0 0 0-1.349 1.349 1.35 1.35 0 0 0 1.349 1.349zm0-2.025c.373 0 .675.303.675.675s-.303.675-.675.675-.675-.303-.675-.675.302-.675.675-.675zM8.72 3.94a1.14 1.14 0 0 0 1.137-1.137A1.14 1.14 0 0 0 8.72 1.666a1.14 1.14 0 0 0-1.138 1.138A1.14 1.14 0 0 0 8.72 3.941zm0-1.6c.255 0 .463.208.463.464s-.208.463-.463.463-.463-.208-.463-.463.207-.464.463-.464zm0 6.444a1.91 1.91 0 0 0 1.908-1.908A1.91 1.91 0 0 0 8.72 4.968a1.91 1.91 0 0 0-1.908 1.908A1.91 1.91 0 0 0 8.72 8.784zm0-3.142c.68 0 1.234.554 1.234 1.234S9.4 8.1 8.72 8.1s-1.234-.554-1.234-1.234.554-1.234 1.234-1.234zm10.037 11.492c-.643 0-1.165.522-1.165 1.165s.522 1.165 1.165 1.165 1.165-.523 1.165-1.165-.523-1.165-1.165-1.165zm0 1.656a.491.491 0 1 1 0-.982.491.491 0 1 1 0 .982zM4.743 17.23c0 .775.63 1.405 1.404 1.405s1.405-.63 1.405-1.405-.63-1.404-1.405-1.404-1.404.63-1.404 1.404zm1.404-.73a.73.73 0 1 1 0 1.461.73.73 0 0 1 0-1.461zm7.168 5.127c1 0 1.833-.822 1.833-1.833s-.822-1.833-1.833-1.833-1.833.822-1.833 1.833.823 1.833 1.833 1.833zm0-3a1.16 1.16 0 0 1 1.159 1.159 1.16 1.16 0 0 1-1.159 1.159 1.16 1.16 0 0 1-1.159-1.159 1.16 1.16 0 0 1 1.159-1.159z"></path></svg>
                                    <div class="errorContent">
                                        <p>{{webmessages.wsm_ccneedToAcceptCookies}}</p>
                                        <p>{{webmessages.wsm_cctoUse}} Youtube</p>

                                        <button class="acceptCookiesBtn" @click="acceptCookiesMethod">{{ webmessages.wsm_ccmodalBtnAcceptAll }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="descWrapper">

                        <h1 class="descWrapperTitle" v-html="videoData.snippet.title"></h1>
                        
                        <p :ref="'desc_'+videoData.id" v-if="showDesc" class="desc">

                            <span class="descContent" v-html="textFormatter(videoData.snippet.description)"></span>

                            <products v-if="!loading" :videoId="videoData.id" :tags="videoData.productIds"></products>
                        </p>
                        
                    </div>
    
                </div>

                 <div v-if="showPlaylistColumn" :class="['contentSidebar']">
                    <div @click="openVideo(nowPlaying, video.id)" v-if="Object.keys(video.snippet.thumbnails).length > 0" v-for="(video, index) in ComputedPlaylistArray" :key="video.id" class="playlistItemWrapper">
                            <video-container :index="index" :video="video" :numberOfCharacters="40"></video-container>
                        
                    </div>
                </div> 
                <div v-else class="noSidebar"></div>
                </div>
            </modal>
    </div>
</template>

<script>
import VModal from 'vue-js-modal/dist/index.nocss.js'
import 'vue-js-modal/dist/styles.css'
import products from '../youtubewidget/src/components/products.vue'
import videoContainer from '../youtubewidget/src/components/videoContainer.vue'
export default {
    name: 'YoutubePlayer3',
    components: {
        VModal,
        products,
        videoContainer
    },
    props: ["videoData", "playListArray"],
    data() {
        return {
            //// DEBUG VARIABLE REMEMBER TO SET TO FALSE BEFORE PUTTING IN PRODUCTION/////
            debug: false,
            /// 
            showDesc: true,
            modalWidth: '90%',
            modalMaxWidth: 1000,
            //videoIsBig: false,
            iframeError: false,
            videoLoading: true,
            embed: false,
            nowPlaying: '',
            loading: false,
            windowWidth: window.outerWidth,
            windowLocationOrigin:'',
            // Debugging variables
            showPlaylistDebug: false,
            // Specific for youTubePlayComponent
            //playListArray: [],
            animation: {
                scaleUp: true,
                endAnimation: false,
                animationHasEnded: false,
                isTestLoading: true,
            },
            webmessagesToFetch: ['wsm_ccdisabledCookies','wsm_ccneedToAcceptCookies','wsm_cctoUse','wsm_ccmodalBtnAcceptAll'],
            webmessages: {},
            cookieBtn: null,
        }
    },
    mounted(){
        this.conlog("youtubePlayer Mounted", window.location.origin)

        // Get webmessages
        this.webmessages = cws(this.webmessagesToFetch);
        this.windowLocationOrigin = window.location.origin;
        this.cookieBtn = window.Ccontrols;
        this.$nextTick(()=>{
            window.addEventListener('resize', this.onResize);
        })
    },
    methods: {
        conlog(message, data){
            if(this.debug){
                console.log("DEBUG:", message, data?data:' ')
            }
        },
        acceptCookiesMethod(){
            this.conlog("COOKIES ACCEPT");
            this.cookieBtn.acceptAllCookies(); 
            this.debugApp();
            this.iframeError = false;
        },
        modalOpened(){
            this.conlog("Youtube Modal has opened: ", this);
            this.checkForIframe(this.$refs[this.videoData.id+'Ref']);
        },
        beforeModalOpen(){
            this.conlog("BEFORE MODAL OPEN")
            this.nowPlaying = this.videoData.id;
        },
        debugApp(){
            this.conlog("DEBUG APP: ", this);
        },
        checkForIframe(ref){
            const containerRef = ref;
            const iframe = containerRef.querySelector("iframe");
            if(iframe){
                // Everything is good - there is an iframe
                this.conlog("WE HAVE AN IFRAME");
            }else{
                // No iframe is found in the container we error handle
                this.conlog("NO IFRAME");
                this.iframeError = true;
                
                // COOKIE ISSUES 
                // wsm_ccdisabledCookies = Cookies er deaktiveret
                // wsm_ccneedToAcceptCookies = Du skal acceptere cookies
                // wsm_cctoUse = for at bruge
            }
        },
        // ERROR HANDELING
        errorYoutube(error){
            this.conlog("YOUTUBE ERROR: ",error)
        },
        // PLAYER SPECIFIC
        videoReady(id){
            this.conlog("READY: " + id)
            this.videoLoading = false;
        },
        videoPlaying(id){
            this.conlog("Playing video id: " + id)
        },
        // PLAYER SPECIFIC

        openVideo(old, val) {
            //this.videoLoading = true;
            old != '' ? this.$modal.hide(old) : '';
            document.getElementsByTagName("body")[0].style.overflow = 'hidden'
            this.$modal.show(val);
        },
        removeOverFlow() {
            this.nowPlaying = ''
            document.getElementsByTagName("body")[0].style.overflow = 'scroll'
        },
        resizeDesc(val) {
            this.$refs[val][0].$el.style.height = '50%';

        },
        closeMe(id) {
            this.removeOverFlow();
            this.$modal.hide(id);
            this.nowPlaying = ''
        },
        textFormatter(text){
            var newText = this.addLinebreaks(text);
            return this.urlify(newText);
            //return newText;
        },
        addLinebreaks(text){
           var linebreakRegex = /(?:\r\n|\r|\n)/g;
           return text.replace(linebreakRegex, ' <br/> ');
        },
        urlify(text) {
            var urlRegex = /(https?:\/\/[^\s]+)/g;
            return text.replace(urlRegex, function(url) {
                return '<a href="' + url + '">' + url + '</a>';
            })
        },
        IsJsonString(str) {
            try {
                JSON.parse(str.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": '));
            } catch (e) {
                return false;
            }
            return true;
        },
        minTwoDigits(n) {
            return (n < 10 ? '0' : '') + n;
        },
        onResize(){
            this.windowWidth = window.innerWidth;
            this.resizeModal();
        },
        resizeModal(){
            if(this.showPlaylistColumn){
                this.windowWidth > 1000? this.modalMaxWidth = 1000:this.modalMaxWidth = 700;
            }else{
                this.windowWidth > 1000? this.modalMaxWidth = 700:this.modalMaxWidth = 700;
            }
        }
    },
    // CREATED
    created() {
        this.resizeModal();
    },
    // COMPUTED
    computed: {
        basedir: function() {
            return basedir;
        },
        // ComputedPlaylistArray filters away the nowPlaying video from the sidebarcontent playListArray array
        ComputedPlaylistArray: function(){
            let newArr = this.playListArray.filter(video => video.id!= this.nowPlaying)
            return newArr;
        },
        showPlaylistColumn: function(){
                if(this.playListArray.length > 0 && this.showPlaylistDebug == false){
                    return true;
                }else{
                    return false;
                }
        }
    },
    watch:{
        // This watch functions main purpose is for debugging
        showPlaylistColumn(newVal, oldval){
            //console.log(newVal, "WATCHING");
            this.resizeModal();
        }
    },
    // BEFORE DESTROY
    beforeDestroy(){
        window.removeEventListener('resize', this.onResize);
    }
}
</script>
<style lang="scss" scoped>
.header {
    height: 39px;
    background: #353535;
    //box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.5803921569);
    i {
        cursor: pointer;
        position: absolute;
        right: 18px;
        top: 7px;
        color: white;
        font-size: 24px;
        z-index: 1;
    }
    p {
        padding: 10px;
        margin: 0;
        font-weight: bold;
        color: white;
    }
}
.modalContentWrapper{
    //height: 100%;
    height: calc(100% - 39px);
    display: grid;
    
    grid-template-rows: 1fr;

    overflow: hidden;
    .header{
        grid-area: header;
    }
    .contentContainer{
        grid-area: videoPlayer;
    }
    .contentSidebar{
        grid-area: sideContent;
    }
    .displayNone{
        display: none;
    }
}
.contentSidebarColumn{
    grid-template-columns: 60% 1fr;
    grid-template-areas: 
    "videoPlayer sideContent"
    "videoPlayer sideContent"; 
}
.noContentSidebarColumn{
    grid-template-columns: 100%;
    grid-template-areas: 
    "videoPlayer"
    "videoPlayer";
}
.contentContainer {
    //width: 65%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;
    //vertical-align: top;
}
.youtubeWrapper{
    background: black;
    display: flex;
    justify-content: center;
    width: 100%;
    //height: 50%;
    //max-height: 45vh;
}
.videoPlayerContainer {
    background: #c9c9c9;
    transition: all 0.4s ease-in-out;
    opacity: 1;
    aspect-ratio: 16/9;
    //width:80%;
    width: 100%;
    //background: red;
    iframe {
        //width: 100%;
        //height: 100%;
    }
}
.errorWrapper.flex{
    display:flex;
    justify-content: center;
    align-items: center;
}
.errorContainer{
    *{margin: 0;}
    background: #fff;
    box-shadow: 0 0.66em 0.31em -0.31em rgba(0, 0, 0, 0.2901960784);
    border-radius: 3px;
    padding: 20px;
}
.errorTitle{
    font-weight: bold;
    margin-bottom: 10px;
}
.errorContent{

}
.acceptCookiesBtn{
display: block;
cursor: pointer;
margin-top: 10px;
width: auto;
padding: 8px;
background: #394448;
border: 1px solid #fff;
color: #fff;
}
.d-inline{
    display: inline;
}
@media only screen and (max-width: 800px){
.contentSidebarColumn{
    grid-template-columns: 100%;
    grid-template-areas: 
    "videoPlayer"
    "sideContent"; 
}
.contentSidebar{
    //overflow: initial;
    overflow-x: initial!important;
    overflow-y: initial!important;
}
    // #videoSlider{
.modalContentWrapper{
    overflow: scroll;
}
.contentContainer{
    overflow: initial;
    .descWrapper{
        overflow: initial;
    }
    .desc{
        height: 100%;
        overflow: initial;
    }
}

}

// LOADING ICON START
.loadingIcon{
    display: flex;
    justify-content: center;
    align-items: center;
    .pnLogoOuterWrapper{
        // Change this font size to size the logo. It's using 'EM' values
        font-size: 16px;
        
        height: 8em;
        width: 8em;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
       // padding: 0.5em;
        //border: 0.5em solid white;

        .pnLogoOuterRing, .pnLogoOuterRing2{
            height: 8em;
            width: 8em;
            border: 0.5em solid white;
            padding: 0.9em;
            position: absolute;
            border-radius: 100%;
            font-size: 100%;

        }
        // .pnLogoOuterRing2{
        //     //animation-name: expandingPadding;
        //     //animation-duration: 2s;
        //     //animation-iteration-count: infinite;
        // }


        .pnLogoInnerWrapper{
            background: white;
            border-radius: 100%;
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center; 
            box-sizing: border-box;
            padding: 1.56em;
            box-shadow: 0 .66em .31em -.31em rgba(0, 0, 0, 0.2901960784);
            font-size:100%;
        }
        svg{
            top: initial;
            height: 100%;
            width: 100%;
        }
        
    }
}
.animationScaleUp{
    animation-name: expandingPadding;
    animation-duration: 2s;
    animation-iteration-count: infinite;

}
.animationScaleOut{
    animation-name: scaleOut;
    animation-timing-function: ease;
    animation-duration: .5s;
    animation-fill-mode: forwards;
}
@media only screen and (max-width: 400px){
        .loadingIcon{
        .pnLogoOuterWrapper{
            font-size: 12px;
        }
        }
        .ytplayer .descWrapper .desc{
                padding: 20px 0;
            }

    
}
// Loading animation
@keyframes loadingRotate{
    0%{transform: rotate(0deg)}
    10%{transform: rotate(0deg)}
    90%{transform: rotate(360deg) }
    100%{transform: rotate(360deg)}
}
@keyframes expandingPadding{
    0%{}
    25%{
        opacity: 1;
        }
    100%{
        //padding: 3em;
        transform: scale(130%);
        opacity: 0;
        border-width: 1px}
}
@keyframes scaleOut{
    0%{transform: scale(100%);}
    20%{transform: scale(110%);}
    100%{transform: scale(0%);}
}
// LOADING ICON END

.noSidebar{
    width:0%;
}
.contentSidebar {
    //display: inline-block;
    //width: 35%;
    background: #00000014;
    padding: 20px;
    //max-height: 96%;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 100%;
    box-sizing: border-box;
    display: grid;
    //grid-template-columns: 1fr;
    grid-template-columns: repeat(auto-fill, minmax(250px, 250px));
    grid-template-rows: auto;
    grid-gap: 20px;
    align-content: start;
    justify-content: center;
}
.playlistItemWrapper{
    //padding: 20px;
    max-width: 100%;
    min-width: 250px;
    box-sizing: border-box;
}


</style>
<style lang="scss">
.ytplayer {
    .vm--modal {
        border-radius: 8px !important;
        transition: all 0.5s ease-in-out;
    }
}

.ytplayer {
    position: relative;

    .youtubeComponent{
        background: #c9c9c9;
        transition: all 0.4s ease-in-out;
        opacity: 1;
        aspect-ratio: 16/9;
        width:100%;
        height: auto;
        iframe {
            width: 100%;
            height: 100%;
        }
        svg {
            text-align: center;
            margin: 0 auto;
            position: relative;
            display: block;
            top: 42%;
        }
    }
    .descWrapper{
        padding: 20px 22px;
        height: 45%;
        overflow: auto;
        overflow-y: auto;
        overscroll-behavior: contain;
        flex-grow: 1;
        .desc {

            word-break: break-word;
            padding: 22px;
            width: auto;
            color: #515151;

        }
    }
}

.hide {
    opacity: 0 !important;
    position: absolute;
    top: 0;
    z-index: -1;
}


</style>

<style lang="scss" scoped>


</style>
